import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { NotificationService } from '../../../../../common';
import { Observable, of } from 'rxjs';
import {
  ShipmentWaybillSapDeliveriesInitialState,
  ShipmentWaybillSapDeliveriesLoad,
} from './shipment-waybill-sap-deliveries.actions';
import { ShipmentSapDeliveryModel } from '../../../../../common/models/shipment-sap-delivery.model';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentWaybillSapDeliveriesService } from './shipment-waybill-sap-deliveries.service';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';

export type ShipmentWaybillSapDeliveriesStateModel = ListServerPaginationStateModel<ShipmentSapDeliveryModel>;

const initialState: ShipmentWaybillSapDeliveriesStateModel = {
  ...LIST_SERVER_PAGINATION_INITIAL_STATE,
};

@State<ShipmentWaybillSapDeliveriesStateModel>({
  name: 'shipmentWaybillSapDeliveries',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillSapDeliveriesState {
  @Selector()
  static getState(state: ShipmentWaybillSapDeliveriesStateModel): ShipmentWaybillSapDeliveriesStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentWaybillSapDeliveriesStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getSapDeliveries(state: ShipmentWaybillSapDeliveriesStateModel): ShipmentSapDeliveryModel[] {
    return state.items;
  }

  constructor(
    private shipmentWaybillSapDeliveriesService: ShipmentWaybillSapDeliveriesService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentWaybillSapDeliveriesLoad)
  getShipmentWaybillSapDeliveries(
    ctx: StateContext<ShipmentWaybillSapDeliveriesStateModel>,
    { payload }: ShipmentWaybillSapDeliveriesLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.shipmentWaybillSapDeliveriesService.getShipmentWaybillSapDeliveries(payload).pipe(
      map((state: ShipmentWaybillSapDeliveriesStateModel) => {
        ctx.patchState({ ...state, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillSapDeliveriesInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillSapDeliveriesStateModel>): void {
    ctx.setState(initialState);
  }
}
